import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { EmbryoLink } from '@/components/common/links';
import { SEX_EMBRYO } from '@/constants';

export const freezeEntryColumnDefs: ColDef[] = [
  {
    headerName: '',
    headerTooltip: '',
    width: 10,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressMovable: true,
    lockPosition: true,
    headerCheckboxSelectionFilteredOnly: true,
  },
  {
    field: 'embryoId',
    headerName: 'Live Embryo',
    width: 110,
    filter: 'agSetColumnFilter',
    valueGetter: (params) => !!params.data?.embryoId,
    cellRenderer: (params: { value: boolean }) => (params.value ? '✓' : '✗'),
  },
  {
    field: 'stateCode',
    headerName: t('common.status'),
    filter: 'agTextColumnFilter',
    width: 100,
    valueFormatter: (params) =>
      params.value === 0 ? 'Active' : params.value === 1 ? 'Inactive' : '',
  },
  {
    field: 'straw',
    headerName: t('straw.straw'),
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'stage',
    headerName: t('embryo.stage'),
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'grade',
    headerName: t('embryo.grade'),
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'cane',
    headerName: t('semen.cane'),
    filter: 'agTextColumnFilter',
    width: 100,
  },
  {
    field: 'sex',
    headerName: t('embryo.sex'),
    filter: 'agSetColumnFilter',
    width: 80,
    valueFormatter: (params) =>
      Object.entries(SEX_EMBRYO).find(
        ([, val]) => val === Number(params.value),
      )?.[0] ?? '',
  },
  {
    field: 'freezeMethodName',
    headerName: t('freeze.freezeMethod'),
    filter: 'agTextColumnFilter',
    width: 120,
  },
  {
    field: 'freezeTech',
    headerName: t('freeze.freezeTech'),
    filter: 'agTextColumnFilter',
    width: 120,
  },
  {
    field: 'freezer',
    headerName: t('freeze.freezer'),
    filter: 'agTextColumnFilter',
    width: 100,
  },
  {
    field: 'storageLocationName',
    headerName: t('storageLocation.storageLocation'),
    filter: 'agTextColumnFilter',
    width: 140,
  },
  {
    field: 'tt',
    headerName: t('freeze.trypsinTreated'),
    filter: 'agSetColumnFilter',
    width: 80,
    valueFormatter: (params) =>
      params.value ? t('common.yes') : t('common.no'),
  },
  {
    field: 'ownerName',
    headerName: t('embryo.ownerName'),
    filter: 'agTextColumnFilter',
    width: 100,
  },
  {
    field: 'embryoName',
    headerName: t('embryo.embryoName'),
    filter: 'agTextColumnFilter',
    width: 120,
    cellRenderer: EmbryoLink,
    cellRendererParams: (params: ICellRendererParams) => ({
      embryoId: params.data?.embryoId as string,
      embryoName: params.data?.embryoName as string,
      openInNewTab: true,
    }),
  },
];
